<template>
    <form class="form-signin">
        <div class="form-group">
            <label for="inputEmail" class="sr-only">E-postadress eller användarnamn</label>
            <input v-model="username" type="text" class="form-control" placeholder="E-postadress eller användarnamn"
                required />
        </div>

        <div class="form-group">
            <label for="inputPassword" class="sr-only">Lösenord</label>
            <input v-model="password" type="password" class="form-control" placeholder="Lösenord" required />
        </div>

        <div class="form-group">
            <button @click.prevent="attemptLogin" class="btn btn-lg btn-primary btn-block" type="submit">
                Logga in
            </button>
        </div>

        <div class="checkbox">
            <label>
                <input v-model="autoLogin" type="checkbox" name="AutoLogin" value="1" />
                <span>Kom ihåg mig</span>
            </label>
            <a href="/aterstall-losenord" class="forgot-password">Glömt lösenord</a>
        </div>
        <div v-if="error" class="alert alert-danger" role="alert">
            {{ error }}
        </div>
    </form>
</template>

<script>
export default {
    mounted() {
        $(document).ready(function () {
            $.get('/includes/ajax/auth.asp');
        });
    },

    data() {
        return {
            username: '',
            password: '',
            autoLogin: false,
            error: false,
            isSubmitting: false,
            baseUrl: window.appConfig.public_url
        };
    },

    computed: {
        realAutoLogin() {
            return this.autoLogin ? 1 : 0;
        }
    },

    methods: {
        attemptLogin() {
            if (this.isSubmitting) return;

            this.error = '';
            this.isSubmitting = true;

            let data = {
                LoginUserName: this.username,
                LoginPassWord: this.password,
                AutoLogin: this.realAutoLogin,
                laravel: 'yes'
            };

            const postRequest = this.baseUrl + '/includes/ajax/auth.asp';

            $.post(postRequest, data)
                .done((response) => {
                    if (response.indexOf('success') > -1) {
                        this.error = '';

                        let url = response.split('\n')[1] || '';

                        url = url.indexOf('http') == 0 ? url : '/' + url;

                        const getRequest =
                            this.baseUrl +
                            '/includes/ajax/notifications.asp?rnd=' +
                            Math.random() +
                            this.getSession();

                        $.get(getRequest)

                            .done(function (res) {
                                window.location = `${appConfig.public_url}/min-sida/`
                            })

                            .fail(function (err) {
                                console.error(res);
                            });


                    } else {
                        this.error = response.split('\n')[0];
                    }
                })
                .always(() => {
                    this.isSubmitting = false;
                });
        },

        getSession() {
            const matches = document.cookie.match(/ASPSESSION[A-Z]{10}=[A-Z]{5}([A-Z]{15})\w+;/);

            console.log('matches', matches);

            return matches && matches.length === 2 ? '&sess=' + matches[1] : '';
        }
    }
};
</script>
